<template>
  <div class="user">

    <div class="photo">
      <div class="icon-big text-center" :class="`text-white`" style="font-size: 24px;">
        <i class="nc-icon nc-single-02"></i>
      </div>
      <!-- <img src="static/img/faces/face-2.jpg"/> -->
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           {{ currentUser ? displayName(currentUser) : 'User' }}
           <!-- <b class="caret"></b> -->
        </span>
      </a>
      <!-- <div /class="clearfix"></div> -->
      <!-- <div> -->
        <!-- <collapse-transition> -->
          <!-- <ul class="nav nav-menu" v-show="!isClosed"> -->
            <!-- <li>
              <a href="#">
                <span class="sidebar-mini-icon">Mp</span>
                <span class="sidebar-normal">My Profile</span>
              </a>
            </li>
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">Ep</span>
                <span class="sidebar-normal">Edit Profile</span>
              </a>
            </li> -->
            <!-- <li>
              <a href="#">
                <span class="sidebar-mini-icon">S</span>
                <span class="sidebar-normal">Settings</span>
              </a>
            </li> -->
          <!-- </ul> -->
        <!-- </collapse-transition> -->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import { CollapseTransition } from 'vue2-transitions'

export default {
  components: {
    CollapseTransition
  },
  data() {
    return {
      isClosed: true
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "$_user/currentUser"
    })
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed
    },
    displayName (user) {
      return user.lastname.substring(0, 1) + '.' + user.firstname
    }
  }
}
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
